var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFactsheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "47px",
    viewBox: "0 0 39 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-fact.sheet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flueid-Desktop-Media",
    transform: "translate(-796.000000, -3565.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 2648.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(796.000000, 912.000000)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "icon-fact.sheet",
    x: 0,
    y: 5,
    width: 39,
    height: 46.8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAABICAYAAACqT5alAAAABGdBTUEAALGOfPtRkwAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAPKADAAQAAAABAAAASAAAAACHja9TAAACLUlEQVR4Ae1bS07DQAwNiEMAqxYuQVlAyzE4BnAXWk7C/xZ8LgALYFVYdAfvoUwVJTOKYjVS7bGlxySemcTPzzIBaYoibhO4r4AX4Af4VQLGyphnwBhotX2seAC0EGyL8w5chinWh5j4MkQ2JOMTnEZ10gM4PoCwyNpIIVm9S7vHlTWSdT6Pge1JBmQD+TFJsxsHR3VcwH8G7ABajLGeA4y9yiVcT0nkNTHJjVrtAoEHktXxmYS+E5PbnFRqjL1KNFzPN8qJGC/OaTaSbNhmw2Pc4YSNC1y4wq6wsQx4SRsTtEFnq+Fpd0R/obdv621Fpw8kL+nedFiTB7vCayJEb2Fkp7CkS3fqir1JJXxwdgo7YWGlqNnmCquRShioKyxMnJptrrAaqYSBusLCxKnZJvmW7vs/Hqlv9dR7U+ujInhJR9NiyOkKGxIzSiU7hSVdulNXjKZZ5lzJe7NT2AnLqk3PLldYj1aySCVdOvVNK4uguSvVjVPvTa1vPhkeL+loWgw5XWFDYkapZKewpEt36orRNMucK3lvdgo7YVm16dnlCuvRShapKyzLm55dWSrMYzwx03RAqx7/bt1R3s+p8Hti8jTh1+BOxf7G4GcA/7iuYwEfT6dpUrrtKN4l+BQToE7W6v0RCdNuAaskA6/rf6bljwFG6wem96qEeT0CeHw8ZMTKSCEPgKgN4bVU3jfgM4gyrTmPcT8FeN42ddx2HSuAsT4B7MbLBoXrpf0Bo/TJXXiCzuoAAAAASUVORK5CYII="
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFactsheet);
export default __webpack_public_path__ + "static/media/icon-fact.sheet.73501cd482044944df9f181904f51f2f.svg";
export { ForwardRef as ReactComponent };